import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material.module';

import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { CardDetailComponent } from './card-detail/card-detail.component';
import { CardTransactionComponent } from './card-transaction/card-transaction.component';
import { DataService } from "./data.service";
import { NgOtpInputModule } from  'ng-otp-input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ConfirmationDialogComponent } from './dialog-box/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './dialog-box/confirmation-dialog/confirmation-dialog.service';
import { CardReplaceDialogComponent } from './dialog-box/card-replace-dialog/card-replace-dialog.component';
import { CardReplaceDialogService } from './dialog-box/card-replace-dialog/card-replace-dialog.service';
import { SetPinDialogComponent } from './dialog-box/set-pin-dialog/set-pin-dialog.component';
import { SetPinDialogService } from './dialog-box/set-pin-dialog/set-pin-dialog.service';
import { AlertModule } from '../app/_alert';
import { OnlynumberDirective } from './directive/onlynumber.directive'
import { VoucherCodeDirective } from './directive/vouchercode.directive';
import { TermsComponent } from './terms/terms.component';

@NgModule({ declarations: [
        TermsComponent,
        AppComponent,
        LoginComponent,
        HomeComponent,
        CardDetailComponent,
        CardTransactionComponent,
        ConfirmationDialogComponent,
        CardReplaceDialogComponent,
        SetPinDialogComponent,
        OnlynumberDirective,
        VoucherCodeDirective
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        AngularMaterialModule,
        NgOtpInputModule,
        NgbModule,
        AlertModule,
        InfiniteScrollModule], providers: [
        DataService,
        ConfirmationDialogService,
        CardReplaceDialogService,
        SetPinDialogService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
